import companyImage from "../../../assets/images/company-bg-min.png";



const CompanySection = (props) => {
    return (
        <section
            ref={props.anchor}
            id="company"
            style={{
                backgroundImage: `url(${companyImage})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                textShadow: "0 0 2px #0006",
            }}
        >
            <div className="container-xl" style={{ padding: "12rem 2rem" }}>
                <div className="row text-light">
                    <div className="col-lg-2 col-sm-auto"></div>
                    <div className="col-lg-10 col-md-12">
                        <h6 className="text-primary text-uppercase">
                            Company
                        </h6>
                        <h1 className="text-light">Compliance ease</h1>
                        <div className="row  mt-4 g-3">
                            <div className="col-md">
                                <h3>Who we are:</h3>
                                <p className="text-body-1" style={{letterSpacing : "-0.5px"}}>
                                    iComply is an automated cloud-based compliance operating system specifically designed for real estate agents to ensure compliance under the Property & Stock Agents Act 2002. It has been developed by agents for agents.
                                </p>
                            </div>
                            <div className="col-md">
                                <h3>What we do:</h3>
                                <p className="text-body-1" style={{letterSpacing : "-0.5px"}}>
                                    iComply implements and operates the compliance software that will enable the business owner or Licensee in charge to stay updated. You will be notified with any changes in compliance so you and your team are compliance ready at all times.  You won’t miss anything.
                                </p>
                            </div>
                            <div className="col-md">
                                <h3>Why you need us:</h3>
                                <p className="text-body-1" style={{letterSpacing : "-0.5px"}}>
                                    Fines are expensive. Loss of license is becoming more common. Missing a compliance deadline can have dire consequences. We know. Hence, we make compliance easy so you can focus on the bigger picture. Imagine being fully compliant with almost no effort? 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanySection ;
